import vue from "../../main";

export default class RoleMapping {
  constructor() {
    this.auth_items = [];
  }

  load() {
    vue.axios.get("settings/role-mapping/mapping-default-user-details").then(resp => {
      this.auth_items = resp.data.auth_items;
    });
  }

  save() {
    return new Promise((resolve, reject) => {
      vue.axios
        .post("settings/role-mapping/save-default-roles", this)
        .then(() => {
          resolve();
        })
        .catch(resp => {
          reject(resp.data);
        });
    });
  }
}
